import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { requestService } from 'src/core/services/api';
import { companiesRoutes } from './routes';
import { USER_SETTINGS_KEYS } from 'src/constants/userSetting';
import { singleElementOfArray } from 'src/utils/singleElementOfArray';
export class Companies {
  constructor() {
    _defineProperty(this, "routes", companiesRoutes);
  }
  async getCompanyProperties(data, options) {
    let getIsBillAutomationEnabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    const companyId = data.companyId;
    if (getIsBillAutomationEnabled) {
      const resp = await requestService('aggregate').get(this.routes.properties(companyId), _objectSpread({}, options.cancelToken));
      return resp.data;
    } else {
      const resp = await requestService('aggregate').get(this.routes.propertiesLegacy(companyId), _objectSpread({}, options.cancelToken));
      return resp.data;
    }
  }
  async getCompanyPropertyList(data, options) {
    const companyId = data.companyId;
    const resp = await requestService('aggregate').get(this.routes.propertyList(companyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async createNewCompany(data, options) {
    const resp = await requestService('property').post(this.routes.baseUrl, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }

  /**
   * The company's bill-intake email address (autobill+{tag}@…), or null when email intake has not been
   * provisioned. Read-only — reading never creates one, because the feature is paid.
   */
  async getBillIntakeAlias(data, options) {
    const resp = await requestService('property').get(this.routes.billIntakeAlias(data.companyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }

  /**
   * Provisions the company's bill-intake address — the deliberate act of enabling email intake for a
   * paying company. Idempotent. Admin-only server-side.
   */
  async provisionBillIntakeAlias(data, options) {
    const resp = await requestService('property').post(this.routes.billIntakeAlias(data.companyId), {}, _objectSpread({}, options.cancelToken));
    return resp.data;
  }

  /** Every bill-intake address the company has held, newest first, each with a status. */
  async getBillIntakeAliasHistory(data, options) {
    const resp = await requestService('property').get(this.routes.billIntakeAliasHistory(data.companyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }

  /**
   * Issues a new bill-intake address. Admin-only on the backend; the old address keeps routing for a
   * grace period so the company can update the utility providers they gave it to.
   */
  async rotateBillIntakeAlias(data, options) {
    const resp = await requestService('property').post(this.routes.billIntakeAliasRotate(data.companyId), {}, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getCompanies(options) {
    var _resp$data;
    const resp = await requestService('property').get(this.routes.baseUrl, _objectSpread({}, options.cancelToken));
    if (resp !== null && resp !== void 0 && (_resp$data = resp.data) !== null && _resp$data !== void 0 && _resp$data.response.length) {
      localStorage.setItem(USER_SETTINGS_KEYS.company, singleElementOfArray(resp.data.response).key);
      localStorage.setItem(USER_SETTINGS_KEYS.companyName, singleElementOfArray(resp.data.response).value);
    }
    return resp.data;
  }
  async getCompany(data, options) {
    const resp = await requestService('aggregate').get(this.routes.company(data.companyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getResidentsAddendums(data, options) {
    const companyId = data.companyId;
    const resp = await requestService('aggregate').get(this.routes.residentAddendums(companyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async getCompanyUnits(data, options) {
    const resp = await requestService('property').get(this.routes.companyUnits(data.companyId), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async updateCompany(companyId, data, options) {
    const resp = await requestService('property').put(this.routes.company(companyId), data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async setConvergentBilling(companyId, options) {
    const resp = await requestService('property').put(this.routes.convergentBilling(companyId), {
      convergentBillingMode: true
    }, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
}